import { render, staticRenderFns } from "./SubAccountSwitch.vue?vue&type=template&id=58e603dc&"
import script from "./SubAccountSwitch.vue?vue&type=script&lang=js&"
export * from "./SubAccountSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e603dc')) {
      api.createRecord('58e603dc', component.options)
    } else {
      api.reload('58e603dc', component.options)
    }
    module.hot.accept("./SubAccountSwitch.vue?vue&type=template&id=58e603dc&", function () {
      api.rerender('58e603dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/SubAccountSwitch.vue"
export default component.exports